import {Center} from '~/components/Center';
import {BlogPageType} from '../../services/GetBlogPageService';
import {SectionContent} from './SectionContent';
import {SectionHeader} from './SectionHeader';
import {SectionRelatedBlogs} from './SectionRelatedBlogs';

export function BlogPage({data}: {data: BlogPageType}) {
  return (
    <>
      <Center className="pb-20 lg:px-20 lg:pt-10">
        <SectionHeader data={data} />

        <SectionContent data={data} />
      </Center>

      <SectionRelatedBlogs data={data} />
    </>
  );
}
